import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { Close } from "@mui/icons-material"
import { Container } from "@mui/system"
import { useEffect, useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import QRCode from "react-qr-code"
import html2canvas from "html2canvas"


export const WhatsappLinkGenerator = () => {
  const [mobileNumber, setMobileNumber] = useState("+91")
  const [customeMessage, setCustomeMessage] = useState("")
  const [ismsgshow, setismsgShow] = useState(false)
  const [isHover, setIsHover] = useState(false)
  const [open, setOpen] = useState(false)
  const [qrValue, setQrValue] = useState("")
  const [errorText, setError] = useState("")
  const [randomID, setRandomID] = useState("")
  var QRCodeRandom = Math.random().toString(18).slice(8)



  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  const handleCustomeMsg = (e) => {
    setCustomeMessage(e.target.value)
    setismsgShow(false)
  }

  const handleClickToOpen = () => {
    setOpen(true)
  }

  const handleToClose = () => {
    setOpen(false)
  }

  const copyToClipboard = (evt) => {
    navigator.clipboard.writeText(evt)
  }

  const downloadQR = () => {
    const input = document.getElementById('qr_code_div')
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        // const pdf = new jsPDF()
        // pdf.addImage(imgData, 'PNG', 0, 0)
        // pdf.save("downloadQrCode.pdf")
        var link = document.createElement("a")
        link.download = "whatsappQrCode.png"
        link.href = "data:" + imgData
        link.click()
      })
  }

  const handleGenerateQr = () => {
    setRandomID(QRCodeRandom)
    console.log("handleGenerateQr: ", mobileNumber)
    if (mobileNumber && mobileNumber !== "+91") {
      var link =
        `https://api.whatsapp.com/send?phone=${mobileNumber}&text=${customeMessage}`
      setQrValue(link)
      handleClickToOpen()
    } else {
      setError("Check your phone number (maybe it's wrong) and try again.")
      document.getElementById("")
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      console.log(customeMessage)
      setismsgShow(true)
      // Send Axios request here
    }, 2000)

    return () => clearTimeout(delayDebounceFn)
  }, [customeMessage])

  return (
    <section style={{ marginTop: "40px" }} className="wtd mb-5">
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "40px",
            paddingBottom: "40px",
            backgroundColor: "#00a82d",
          }}
        >
          <div
            style={{ flexDirection: "column", flex: 1, textAlign: "center" }}
          >
            <p style={{ color: "white", marginBottom: "5px" }}>
              <strong>GROW YOUR BUSINESS WITH WHATSTOOL BUSINESS</strong>
            </p>
            <div style={{ marginTop: "0px", color:"white" }} className="h1">
              Free WhatsApp
              <span>
                <img
                  src="https://whatstool.in/widget/whatsapp-circle.png"
                  alt="whatstool img"
                  style={{
                    height: "36px",
                    width: "36px",
                    display: "inline-block",
                    marginBottom: "3px",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                />
              </span>
              Link {<br></br>}
              Generator
            </div>
          </div>
        </div>

        <div style={{ marginTop: "70px" }}>
          <Row>
            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "50px",
                }}
              >
                <div>
                  <h5>
                    Create your free WhatsApp link here
                  </h5>
                  <Card
                    style={{
                      marginTop: "40px",
                      maxWidth: "25rem",
                      padding: "15px 12px 15px 12px",
                    }}
                  >
                    <div>
                      <p style={{ marginBottom: "8px", marginTop: "20px" }}>
                        <strong>Enter Your Whatsapp number</strong>
                      </p>
                      <input
                        id="numberInputText"
                        type="number"
                        placeholder="Your phone number with country code"
                        style={{ padding: "7px" }}
                        onChange={(e) => {
                          setError("")
                          setMobileNumber(e.target.value)
                        }}
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          color: errorText ? "red" : "black",
                        }}
                      >
                        {errorText
                          ? errorText
                          : "Note: enter number with country code"}
                      </p>
                      <p style={{ marginBottom: "8px", marginTop: "20px" }}>
                        <strong>Add Your Custom Message</strong>
                      </p>
                      <textarea
                        id="messageInputText"
                        type="text"
                        placeholder="Add custom message that user send to you"
                        style={{
                          padding: "7px",
                          width: "100%",
                          height: "90px",
                        }}
                        onChange={(e) => {
                          handleCustomeMsg(e)
                        }}
                      />
                      <p style={{ fontSize: "14px" }}>
                        Example: “Hello, I am interested to know more about your
                        business”.
                      </p>
                      <div style={{ marginTop: "20px" }}>
                        <Card
                          style={{
                            padding: "8px 6px 8px 6px",
                            display: "flex",
                            backgroundColor: isHover ? "lightblue" : "#fff",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          role="button"
                          onClick={() => {
                            var link = `https://api.whatsapp.com/send?phone=${mobileNumber}&text=${customeMessage}`;
                            window.open(link);
                          }}
                        >
                          Preview
                        </Card>
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        or
                      </div>
                      <div
                        style={{
                          width: "100%",
                          backgroundColor: "#00a82d",
                          marginBottom: "20px",
                          marginTop: "25px",
                          padding: "10px",
                          borderRadius: "8px",
                          textAlign: "center",
                          color: "white",
                          fontWeight: "bold",
                        }}
                        role="button"
                        onClick={() => {
                          handleGenerateQr()
                        }}
                      >
                        Generate Link
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
              <p className="text-center">
                This is how your message will be displayed
              </p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  class="border-steel-light"
                  style={{
                    minWidth: "18rem",
                    width: "20rem",
                    height: "560px",
                    paddingTop: "2.5rem",
                    paddingLeft: "0.75rem",
                    paddingBottom: "2.5rem",
                    paddingRight: "0.75rem",
                    borderRadius: "12px",
                    border: "solid",
                    background: "#272727",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      width: "100%",
                      height: "100%",
                      position: "relative",
                      backgroundImage:
                        `url("https://assets.gallabox.com/gb-home/wa-background.png")`,
                      backgroundSize: "100%",
                    }}
                  >
                    <div style={{ display: "flex", height: "2.9rem", alignItems: "center", paddingLeft: 2.5, background: "#128c7e" }}>
                      <img
                        src="https://gallabox.com/emptyprofilpic.svg"
                        style={{
                          height: "2.5rem",
                          width: "2.5rem",
                          borderRadius: "1.25rem",
                        }}
                        alt="img"
                      />
                      <div class="text-white" style={{ paddingLeft: 5 }}>
                        {mobileNumber}
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {customeMessage && ismsgshow &&
                          (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                width: "100%",
                                paddingRight: "10px",
                              }}
                            >
                              <p
                                style={{
                                  backgroundColor: "#dcf8c6",
                                  padding: "8px",
                                  borderRadius: "12px",
                                  maxWidth: "13rem",
                                  wordBreak: "break-all",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                {customeMessage}
                              </p>
                            </div>
                          )}
                        <div
                          class="flex gap-x-2.5 h-12 p-2 w-full"
                          style={{
                            display: "flex",
                            gap: "10px",
                            height: "48px",
                            padding: 2,
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              background: "#fff",
                              width: "83.333333%",
                              borderRadius: "12px",
                              height: "91.666667%",
                            }}
                          >
                            <p
                              class="px-2 py-1 my-0 mx-3.5"
                              style={{
                                color: "black",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                fontSize: "0.75rem",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {!ismsgshow && customeMessage}
                            </p>
                          </div>
                          <div
                            style={{
                              backgroundColor: "#128c7e",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              borderRadius: "16px",
                              height: "32px",
                              width: "32px",
                              boxShadow: "revert",
                            }}
                          >
                            <i class="flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18"
                                height="18"
                                style={{ marginBottom: "3px" }}
                              >
                                <path
                                  fill="currentColor"
                                  d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"
                                >
                                </path>
                              </svg>
                            </i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <Dialog
            open={open}
            onClose={() => {
              handleToClose()
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Close
                role="button"
                style={{ margin: "8px" }}
                onClick={() => {
                  handleToClose()
                }}
              />
            </div>
            <DialogTitle>
              <h3>
                <strong>
                  Your WhatsApp link and QR code has been generated!
                </strong>
              </h3>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <p>
                  Copy it and share it via emails, messaging, your website or
                  even social media. Your desired users can contact you in just
                  one click. Download the QR code to share it anywhere.
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <a
                    lass="text-xs text-blue-500"
                    target="_blank"
                    rel="noreferrer"
                    href={qrValue}
                  >
                    wame.whatstool.in/{randomID}
                  </a>
                </div>
                {qrValue &&
                  (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        id="qr_code_div"
                        style={{
                          height: "auto",
                          margin: "0 auto",
                          maxWidth: 180,
                          width: "100%",
                          padding: "12px"
                        }}
                      >
                        <QRCode
                          id="qr-code"
                          size={256}
                          style={{
                            height: "auto",
                            maxWidth: "100%",
                            width: "100%",
                          }}
                          value={qrValue}
                          viewBox={`0 0 256 256`}
                        />
                      </div>
                    </div>
                  )}
              </DialogContentText>
            </DialogContent>
            <div
              style={{
                backgroundColor: "gray",
                height: "0.5px",
                margin: "0px 20px 0px 20px",
              }}
            >
            </div>
            <DialogActions style={{ margin: "5px 0px 5px 0px" }}>
              <button type="button" style={{
                padding: "6px 20px",
                background: "#00a82d",
                color: "#fff",
                border: "none",
                fontSize: "14px",
                borderRadius: "6px",
                marginRight: "6px"
              }}
                onClick={() => {
                  copyToClipboard(qrValue)
                }}>
                Copy Link
              </button>

              <button type="button" style={{
                padding: "6px 20px",
                background: "#00a82d",
                color: "#fff",
                border: "none",
                fontSize: "14px",
                borderRadius: "6px",
                marginRight: "10px"
              }}
                onClick={() => {
                  downloadQR()
                }}>Download QR</button>

            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </section>
  )
}
